module.exports = __webpack_public_path__ + "static/media/settings.4adb2975.svg";